<template>
  <section class="home_promotion_link_area">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="title">
            推廣連結
          </div>
          <div class="line" />
        </div>
      </div>

      <div class="promotion_link_block row">
        <template v-if="getLinks.length > 0">
          <div
            v-for="link in getLinks"
            :key="link.link_id"
            class="col-12 col-sm-6 col-md-4 col-lg-3"
          >
            <a
              v-if="link.link_id"
              class="promotion_link_item"
              :href="link.link_url"
              :style="`background-image: url('${link.link_image}')`"
            />
          </div>
        </template>
      </div>

      <router-link
        to="/promotion-links"
        class="more_btn"
      >
        more
        <font-awesome-icon icon="sign-out-alt" />
      </router-link>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'PromotionLinks',
  computed: {
    ...mapGetters('pages/home', [
      'getLinks'
    ])
  },
  async created () {
    await this.getHomeLinkData()
  },
  methods: {
    ...mapActions('pages/home', [
      'getHomeLinkData'
    ])
  }
}
</script>
